import { render, staticRenderFns } from "./ziyouchePrice.vue?vue&type=template&id=07438d2c&scoped=true&"
import script from "./ziyouchePrice.vue?vue&type=script&lang=js&"
export * from "./ziyouchePrice.vue?vue&type=script&lang=js&"
import style0 from "./ziyouchePrice.vue?vue&type=style&index=0&id=07438d2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07438d2c",
  null
  
)

export default component.exports